import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/StationByKioskCameras/Get`, payload),
    GetActive: (payload) => Repository.post(`/api/StationByKioskCameras/GetActive`, payload),
    GetById: (payload) => Repository.post(`/api/StationByKioskCameras/GetById`, payload),
    Add: (payload) => Repository.post(`/api/StationByKioskCameras/Add`, payload),
    Edit: (payload) => Repository.post(`/api/StationByKioskCameras/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/StationByKioskCameras/Delete`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/StationByKioskCameras/ChangeStatus`, payload),
}
